import { Game } from './Game';

const game = new Game();
game.init().catch(console.error);
